import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllCustomPackages = (params) => {
  const queryParams = new URLSearchParams(params);

  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);
  if (params.search?.trim()) queryParams.append("name", params.search);

  const finalUrl = queryParams.toString()
    ? `${endPoints.getAllCustomPackages}?${queryParams.toString()}`
    : `${endPoints.getAllCustomPackages}`;

  return Api(finalUrl, null, requestType.GET);
};

const fetchCustomPackageDetail = (id) => {
  return Api(endPoints.getCustomPackageDetail.replace(":id", id), null, requestType.GET);
};

const updateCustomPackageByUrl = (url, payload) => {
  return Api(endPoints.customPackageUpdate.replace(":url", url), payload, requestType.PUT);
};

const deleteCustomPackage = (id) => {
  return Api(endPoints.deleteCustomPackage.replace(":id", id), null, requestType.DELETE);
};

const exportCustomPackages = () => {
  return Api(endPoints.exportCustomPackages, null, requestType.GET);
};

export {
  getAllCustomPackages,
  fetchCustomPackageDetail,
  updateCustomPackageByUrl,
  deleteCustomPackage,
  exportCustomPackages,
};
